/**
 * Client Service
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.2.9
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface ClientFilterSubscriptionRequest { 
    name?: string;
    subscriptions?: Array<ClientFilterSubscriptionRequest.SubscriptionsEnum>;
    statuses?: Array<ClientFilterSubscriptionRequest.StatusesEnum>;
    almostExpired?: boolean;
    pendingRequestsOnly?: boolean;
}
export namespace ClientFilterSubscriptionRequest {
    export type SubscriptionsEnum = 'CLIPPING' | 'ANALYTICS' | 'TRANSCRIPTIONS' | 'CONTRACT_NOTICES' | 'CONTRACT_NOTICES_KOSOVO' | 'CONTRACT_NOTICES_ALBANIA' | 'CONTRACT_NOTICES_ANNOUNCEMENTS' | 'CONTRACT_NOTICES_ANNOUNCEMENTS_KOSOVO' | 'CONTRACT_NOTICES_ANNOUNCEMENTS_ALBANIA' | 'SALES' | 'BANKRUPTCIES';
    export const SubscriptionsEnum = {
        CLIPPING: 'CLIPPING' as SubscriptionsEnum,
        ANALYTICS: 'ANALYTICS' as SubscriptionsEnum,
        TRANSCRIPTIONS: 'TRANSCRIPTIONS' as SubscriptionsEnum,
        CONTRACTNOTICES: 'CONTRACT_NOTICES' as SubscriptionsEnum,
        CONTRACTNOTICESKOSOVO: 'CONTRACT_NOTICES_KOSOVO' as SubscriptionsEnum,
        CONTRACTNOTICESALBANIA: 'CONTRACT_NOTICES_ALBANIA' as SubscriptionsEnum,
        CONTRACTNOTICESANNOUNCEMENTS: 'CONTRACT_NOTICES_ANNOUNCEMENTS' as SubscriptionsEnum,
        CONTRACTNOTICESANNOUNCEMENTSKOSOVO: 'CONTRACT_NOTICES_ANNOUNCEMENTS_KOSOVO' as SubscriptionsEnum,
        CONTRACTNOTICESANNOUNCEMENTSALBANIA: 'CONTRACT_NOTICES_ANNOUNCEMENTS_ALBANIA' as SubscriptionsEnum,
        SALES: 'SALES' as SubscriptionsEnum,
        BANKRUPTCIES: 'BANKRUPTCIES' as SubscriptionsEnum
    };
    export type StatusesEnum = 'ACTIVE' | 'EXPIRED' | 'NO_SUBSCRIPTION';
    export const StatusesEnum = {
        ACTIVE: 'ACTIVE' as StatusesEnum,
        EXPIRED: 'EXPIRED' as StatusesEnum,
        NOSUBSCRIPTION: 'NO_SUBSCRIPTION' as StatusesEnum
    };
}